import { client } from "../../../api/client";

export const fetchLegacyDesignPacks = async () => {
    try {
        const response = await client.get(process.env.REACT_APP_GATEWAY_URI, "importexportapi/iquote1/getDesignPacks");
        return response.data;
    } catch (error) {
        console.error("Error fetching legacy DPs", error);
        return { entries: [], totalEntries: 0 };
    }
}

export const fetchDesignPackEntriesByDesignPackRevisionId = async (designPackRevisionId) => {
    try {
        const response = await client.get(process.env.REACT_APP_GATEWAY_URI, `importexportapi/iquote1/getDesignPackEntries/quoteRevision/${designPackRevisionId}`);  
        return response.data;
    } catch (error) {
        console.error("Error fetching legacy DP entries by quote revision id:", error);
        return [];
    }
}

export const fetchLegacyDesignPacksByFilter = async (body) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        return { entries: [], totalDesignPacks: 0 };
    }

    try {
        const response = await client.post(process.env.REACT_APP_GATEWAY_URI, "importexportapi/iquote1/getDesignPacks/filter", body);
        return response.data;
    } catch (error) {
        console.error("Error fetching legacy DPs by filter:", error);
        return { entries: [], totalDesignPacks: 0 };
    }
};